function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1860",
  "data-name": "Group 1860",
  transform: "translate(-1039 -1339)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_288",
  "data-name": "Rectangle 288",
  width: 154,
  height: 25,
  transform: "translate(1039 1339)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1859",
  "data-name": "Group 1859",
  transform: "translate(22.534 185)"
}, /*#__PURE__*/React.createElement("text", {
  id: "CLICK_TO_EXPAND",
  "data-name": "CLICK TO EXPAND",
  transform: "translate(1084.466 1170)",
  fontSize: 10,
  fontFamily: "ProximaNova-Medium, Proxima Nova",
  fontWeight: 500,
  letterSpacing: "0.2em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -55.97,
  y: 0
}, "CLICK TO EXPAND"))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1858",
  "data-name": "Group 1858",
  transform: "translate(551 -198.624)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_80",
  "data-name": "Ellipse 80",
  cx: 9.5,
  cy: 9.5,
  r: 9.5,
  transform: "translate(619 1540.624)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1855",
  "data-name": "Group 1855",
  transform: "translate(623.919 1545.068)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1854",
  "data-name": "Group 1854",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_24",
  "data-name": "Line 24",
  y2: 10.642,
  transform: "translate(4.561 0)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_25",
  "data-name": "Line 25",
  x1: 9.877,
  transform: "translate(0 5.321)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})))));

var SvgExpandCta = function SvgExpandCta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 25,
    viewBox: "0 0 154 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpandCta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Expand_CTA.205914b6.svg";
export { ForwardRef as ReactComponent };